<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container" style="width: 30%;">
                <div class="modal-header">
                    <slot name="header">
                        <h3 class="form-header">Reverse {{$store.state.company.type == 'warehouse' ?  'Destruction' : 'Disposal'}}</h3>
                        <button @click="closeModal" class="red-close-button">
                            <i class="pi pi-times" style='padding: 0'></i>
                        </button>
                    </slot>
                </div>
                <div class="modal-body">
                    <slot name="body">
                        <!-- action="{{ url('payment') }}" -->
                        <!-- aria-label="{{ __('PaymentSubmit') }}" -->
                        <form class="action-modal">

                            <!-- BASIC INFO -->
                            <!-- BASIC INFO -->
                            <div class="form-section-container">
                                <div class="left-form-section-panel">

                                    <div>
                                        <p class="note-header">Notes</p>
                                        <textarea name="notes" id="note-modal" cols="44" rows="16"
                                            placeholder="Enter notes here..." v-model="form.submit.notes" style="border-top-right-radius: 0; border-top-left-radius: 0;"></textarea>
                                    </div>
                                </div>

                                <!-- RIGHT SIDE PANEL -->
                                <div class="right-form-section-panel"
                                    style="display: flex; flex-direction: column; justify-content: space-between;">

                                    <div class="right-form-section-drug-container">
                                        <table style="border-collapse: collapse">

                                            <tr v-for="(item, index) in payload.items" :key="index"
                                                class="drug-entry-transfer">
                                               <td>
                                                    <p>{{ item.date }}</p>
                                                </td>
                                                 <td style="width: 50%;">
                                                    <p>{{ item.alias.name }}
                                                        <!-- {{ Number(item.alias.strength).toFixed(1) }}{{
                                                                item.alias.form_description
                                                        }} -->
                                                    </p>
                                                    <!-- The batch the stock was disposed from, read off the
                                                         disposal's ledger row. Shown for confirmation only: the
                                                         reversal returns the stock to the batch it came off, so
                                                         there is nothing here to choose. -->
                                                    <p v-if="item.batch_number" style="font-size: 0.85em; opacity: 0.8;">
                                                        Batch: {{ item.batch_number }}
                                                    </p>
                                                </td>
                                                <td>
                                                    <p>{{ item.quantity }} {{ item.alias.form }}{{ item.quantity > 1 ?
                                                            's' : ''
                                                    }}</p>
                                                </td>
                                                <td style="border-left: 2px solid white">
                                                    <p v-if="item.user">{{ item.user.personal_information.first_name }}
                                                        {{ item.user.personal_information.last_name }}</p>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <!-- <div style="margin-top: 20px;">
                                <h3 style="margin: 0; text-align: left; margin-bottom: 10px">Approval</h3>
                                <DualVerify @user="getUsername" witness='witness' @pass="getPassword" :password="form.submit.password"  :username="form.submit.username"
                            @user2="getUsername2" @pass2="getPassword2" :password2="form.submit.witness_name"  :username2="form.submit.witness_role" class="full-width-verify" style='justify-content: flex-start'/>
                            </div> -->

                                </div>
                            </div>
                        </form>
                    </slot>
                </div>
                <p style="color: red; font-weight: 500; font-size: 1em;">{{ errorMessage }}</p>
                <div class="modal-footer" style="display: flex; justify-content: flex-end; padding: 5px 20px;">
                    <slot name="footer" style="display: flex;">
                        <p class="regular-button error-button" style="color: white; margin-right: 10px;" @click="closeModal">Cancel
                        </p>
                        <p :class="buttonchangeUi()" @click="submitDestroy()">Reverse</p>
                    </slot>
                </div>
            </div>
        </div>
        <SignatureModal :dual="true" :payload="form.submit" v-if="displaySignatureModal" :witness="witness"
            @isSuccessful="isSuccessful" @close="close" endpoint="/reverse-destruction"/>
    </div>
</template>

<script>
// import DualVerify from '@/components/verification/DualVerify.vue';
import SignatureModal from '@/components/modals/SignatureModal.vue';

export default {
    props: ['transferType', 'payload', 'pending', "success","filterStatus"],
    components: {
        // DualVerify,
        SignatureModal
    },
    data() {
        return {
            witness: true,
            displaySignatureModal: false,
            errorMessage: '',
            newLoc: '',
            stock: '',
            reasonCat: '',
            reasonSubCat: '',
            qty: null,
            location: '',
            addNewLocation: false,
            noLocationFound: false,
            refinedLocations: null,
            refinedDrugs: [],
            form: {
                submit: {
                    notes: '',
                    items: [],
                }
            },
            destroy_form: {
                sort_direction: '',
                col: '',
                page: 1,
                location: this.$store.state.uuid,
                filters: {
                    status: this.filterStatus,
                    drug: '',
                    patient: '',
                    date: {
                        start: '',
                        end: ''
                    },
                }
            },
        }
    },
    methods: {
        closeModal() {
            console.log('hitting this closemodal function')
            this.$emit('close', true);
        },
        closeLocationModal(value) {
            if (value) {
                this.addNewLocation = false;
            }
        },
        close(value) {
            if (value) {
                this.displaySignatureModal = false;
            }
        },
        isSuccessful(value) {
            if (value) {
                this.$store.dispatch('getDestructionItems', this.destroy_form);
                this.closeModal();
                this.$emit("success", true)
            }
        },
        buttonchangeUi() {
            if (this.form.submit.notes && this.payload.items?.length > 0) {
                return 'regular-button green-button'
            }
            else {
                return 'regular-button grey-button'
            }
        },
        submitDestroy() {
            console.log('this is the form to submit', this.form);
            if (this.form.submit.notes && this.payload.items?.length > 0) {
                this.errorMessage = ''
                this.payload.items.forEach(item => {
                    this.form.submit.items.push({
                        uuid: item.uuid,
                    });
                })

                this.witness = false;
                this.displaySignatureModal = true;
            } else {
                const validationMessage = !this.form.submit.notes && this.payload.items?.length <= 0 ? "Drugs and Notes are Required." : this.payload.items?.length <= 0 ? "Drugs is Requireed" : "Notes is required"
                this.errorMessage = validationMessage
            }

            this.refinedLocations = [];

            // this.form = {
            //     submit:{
            //         reason: '',
            //         method:'',
            //         notes: '',
            //         witness_role: '',
            //         witness_name: '',
            //         pending: false,
            //         username: '',
            //         password: '',
            //     }
            // }
        },
    },
    mounted() {
        console.log("payload>>",this.payload);
    }
}
</script>

<style lang="scss">
@import "../../assets/css/main.scss";

 

 

.left-form-section-panel {
    padding: 0 20px;

    p {
        margin: 0;
    }

    textarea {
        border: none;
        background-color: #E5F1FE; //$babyblue;
        border-radius: 4px;
        padding: 10px;
    }

    .search-container input {
        background-color: #E5F1FE; //$babyblue;
    }
}


.right-form-section-drug-entry {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    input {
        background-color: #E5F1FE; //$babyblue;
    }
}

 

.drug-entry-transfer {
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    border-collapse: collapse;

    p {
        margin: 0;
        text-align: left;
        padding: 0 15px;
    }

    background-color: $grey;
    border-radius: 4px;
    margin-bottom: 10px;
    padding: 5px 10px;
    border-bottom: 5px solid white;
    border-radius: 4px;
}


.blue-button {
    background-color: #0870DC !important; //$strongblue !important;
    padding: 5px 20px;
    border-radius: 4px;
    cursor: pointer;
    margin: 0;
    color: white;
}

.right-form-section-panel {
    padding: 0 20px;
}

.full-width-verify.verification-form {
    grid-template-columns: 1fr 1fr;

    div {
        width: 100%;

        input {
            width: 100% !important;
        }
    }
}

.selected-location {
    background-color: #00AD50; //$complete;
    color: white;
}

.selected-hollow-button {
    background-color: #0870DC; //$strongblue;
    color: white;
}
</style>
